<template>
  <div>
<div class="flex justify-between items-start">
  <div class="flex gap-2 mb-6">
      <button @click="activeTab = 'cash'" :class="tabBtnClass('cash')">
        Nakit Kasa
      </button>
      <button @click="activeTab = 'creditCard'" :class="tabBtnClass('creditCard')">
        Kredi Kartı
      </button>
      <button @click="activeTab = 'veresiye'" :class="tabBtnClass('veresiye')">
        Veresiye
      </button>
    </div>
    <div>
      <button @click="exportToExcel"
        class="bg-primary-button hover:bg-primary-button-hover text-white px-4 py-2 rounded text-sm">
        Excel Çıktı
      </button>
    </div>
</div>

    <div v-if="activeTab === 'cash'">
      <div class="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6">
        <div class="bg-white dark:bg-gray-800 p-4 rounded-lg shadow border border-light-border dark:border-dark-border">
          <h3 class="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">Toplam Nakit Giriş</h3>
          <p class="text-2xl font-bold text-green-600">{{ formatPrice(cashTotalIncome) }} ₺</p>
        </div>
        <div class="bg-white dark:bg-gray-800 p-4 rounded-lg shadow border border-light-border dark:border-dark-border">
          <h3 class="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">Toplam Nakit Çıkış</h3>
          <p class="text-2xl font-bold text-red-600">{{ formatPrice(cashTotalExpense) }} ₺</p>
        </div>
        <div class="bg-white dark:bg-gray-800 p-4 rounded-lg shadow border border-light-border dark:border-dark-border">
          <h3 class="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">Net Nakit Bakiye</h3>
          <p class="text-2xl font-bold" :class="cashNetBalance >= 0 ? 'text-green-600' : 'text-red-600'">
            {{ formatPrice(cashNetBalance) }} ₺
          </p>
        </div>
        <div class="bg-white dark:bg-gray-800 p-4 rounded-lg shadow border border-light-border dark:border-dark-border">
          <h3 class="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">Canlı Kasa</h3>
          <p class="text-2xl font-bold" :class="liveCashTotal >= 0 ? 'text-green-600' : 'text-red-600'">
            {{ formatPrice(liveCashTotal) }} ₺
          </p>
        </div>
        <div class="bg-white dark:bg-gray-800 p-4 rounded-lg shadow border border-light-border dark:border-dark-border">
          <h3 class="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">Toplam Veresiye (Dönem)</h3>
          <p class="text-2xl font-bold text-orange-600">{{ formatPrice(totalLoanAmount) }} ₺</p>
        </div>
      </div>

      <div class="flex flex-col md:flex-row items-end justify-between mb-4 gap-4">
        <div class="flex gap-2">
          <button @click="filterType = 'all'" :class="btnClass('all')">Tümü</button>
          <button @click="filterType = 'in'" :class="btnClass('in')">Girişler</button>
          <button @click="filterType = 'out'" :class="btnClass('out')">Çıkışlar</button>
        </div>

        <div class="flex flex-wrap gap-2 items-end">
          <div>
            <label class="block text-xs text-gray-600 dark:text-gray-400 mb-1">Başlangıç Tarihi</label>
            <input type="date" v-model="startDate"
              class="h-10 px-3 rounded-lg border border-light-border dark:border-gray-600 bg-primary-bg dark:bg-gray-800 text-sm text-primary-text dark:text-gray-100 focus:border-indigo-500 focus:ring focus:ring-blue-100/50" />
          </div>
          <div>
            <label class="block text-xs text-gray-600 dark:text-gray-400 mb-1">Bitiş Tarihi</label>
            <input type="date" v-model="endDate"
              class="h-10 px-3 rounded-lg border border-light-border dark:border-gray-600 bg-primary-bg dark:bg-gray-800 text-sm text-primary-text dark:text-gray-100 focus:border-indigo-500 focus:ring focus:ring-blue-100/50" />
          </div>
          <button @click="applyFilter"
            class="bg-primary-button hover:bg-primary-button-hover text-white px-4 py-2 rounded text-sm">
            Filtrele
          </button>
        </div>
      </div>

      <div
        class="overflow-hidden rounded-md border border-light-border dark:border-dark-border bg-primary-bg dark:bg-primary-dark-bg shadow-md">
        <div class="w-full overflow-x-auto">
          <table class="min-w-full text-left text-sm dark:text-gray-300">
            <thead class="bg-gray-100 dark:bg-gray-800 font-medium">
              <tr>
                <th class="px-3 md:px-6 py-2 md:py-4">Tarih</th>
                <th class="px-3 md:px-6 py-2 md:py-4">Tip</th>
                <th class="px-3 md:px-6 py-2 md:py-4">Açıklama</th>
                <th class="px-3 md:px-6 py-2 md:py-4 text-right">Tutar (₺)</th>
                <th class="px-3 md:px-6 py-2 md:py-4 text-right"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="isLoading">
                <td colspan="5" class="text-center py-6 text-gray-500 dark:text-gray-400">
                  Yükleniyor...
                </td>
              </tr>
              <tr v-else-if="filteredCashTransactions.length === 0">
                <td colspan="5" class="text-center py-6 text-gray-500 dark:text-gray-400">
                  Hiç kayıt bulunamadı.
                </td>
              </tr>

              <tr v-for="item in filteredCashTransactions" :key="item.id"
                class="border-b border-light-border dark:border-dark-border transition hover:light-hover dark:hover:dark-hover">
                <td class="px-3 md:px-6 py-2 md:py-4">{{ formatDate(item.created_at) }}</td>
                <td class="px-3 md:px-6 py-2 md:py-4">
                  <span :class="item.type === 'in' ? 'bg-green-100 text-green-700 px-2 py-1 rounded text-xs font-medium' : 'bg-red-100 text-red-700 px-2 py-1 rounded text-xs font-medium'">
                    {{ item.type === 'in' ? 'Giriş' : 'Çıkış' }}
                  </span>
                </td>
                <td class="px-3 md:px-6 py-2 md:py-4">
                  <span v-if="isLoanPayment(item)" 
                        @click="goToLoanDetail(item)" 
                        class="cursor-pointer text-blue-600 hover:text-blue-800 underline">
                    {{ item.description }}
                  </span>
                  <span v-else>{{ item.description }}</span>
                </td>
                <td class="px-3 md:px-6 py-2 md:py-4 text-right">{{ formatPrice(item.amount) }} ₺</td>
                <td class="px-3 md:px-6 py-2 md:py-4 text-right">
                  <div class="flex justify-end gap-2">
                    <button v-if="!isLoanPayment(item) && item.driver_id" @click="convertToLoan(item)" 
                      class="ml-3" title="Veresiye'ye Çevir">
                      <ArrowPathIcon class="w-5 h-5 text-blue-500 hover:text-blue-700" />
                    </button>
                    <button v-if="!isLoanPayment(item)" @click="openEditModal(item)" class="ml-3" title="Düzenle">
                      <PencilSquareIcon class="w-5 h-5 text-gray-500 hover:text-secondary-text" />
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
    
      <div class="my-4">
        <AppPagination 
          :currentPage="currentPage" 
          :totalPages="totalPages" 
          :pageSize="pageSize"
          :totalItems="totalItems"
          @prev-page="handlePageChange(currentPage - 1)"
          @next-page="handlePageChange(currentPage + 1)"
          @go-to-page="handlePageChange"
          @update:pageSize="handlePageSizeChange"
        />
      </div>
      </div>

      <div class="bg-white dark:bg-primary-dark-bg p-6 rounded-lg shadow border border-light-border dark:border-dark-border mt-6">
        <h2 class="text-lg font-semibold mb-2">Yeni Nakit Kasa Kaydı Ekle</h2>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          <div>
            <label class="block mb-1">Tutar (₺)</label>
            <input v-model.number="form.amount" type="number" placeholder="Tutar giriniz"
              class="w-full border border-light-border dark:border-dark-border rounded px-3 py-2 dark:bg-gray-800 dark:text-white" />
          </div>
          <div>
            <label class="block mb-1">Tip</label>
            <select v-model="form.type"
              class="w-full border border-light-border dark:border-dark-border rounded px-3 py-2 dark:bg-gray-800 dark:text-white">
              <option disabled value="">Seçiniz</option>
              <option value="in">Giriş</option>
              <option value="out">Çıkış</option>
            </select>
          </div>
          <div>
            <label class="block mb-1">Açıklama</label>
            <input v-model="form.description" type="text" placeholder="Açıklama"
              class="w-full border border-light-border dark:border-dark-border rounded px-3 py-2 dark:bg-gray-800 dark:text-white" />
          </div>
        </div>

        <div class="flex justify-end">
          <button @click="submitTransaction"
            class="bg-primary-button hover:bg-primary-button-hover text-white px-4 py-2 rounded transition-all duration-200 text-sm">
            Kaydet
          </button>
        </div>
      </div>
    </div>

    <div v-if="activeTab === 'creditCard'">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div class="bg-white dark:bg-gray-800 p-4 rounded-lg shadow border border-light-border dark:border-dark-border">
          <h3 class="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">Toplam Kredi Kartı Giriş</h3>
          <p class="text-2xl font-bold text-green-600">{{ formatPrice(creditCardTotalIncome) }} ₺</p>
        </div>
        <div class="bg-white dark:bg-gray-800 p-4 rounded-lg shadow border border-light-border dark:border-dark-border">
          <h3 class="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">Toplam Kredi Kartı Çıkış</h3>
          <p class="text-2xl font-bold text-red-600">{{ formatPrice(creditCardTotalExpense) }} ₺</p>
        </div>
      </div>

      <div class="flex flex-col md:flex-row items-end justify-between mb-4 gap-4">
        <div class="flex gap-2">
          <button @click="filterType = 'all'" :class="btnClass('all')">Tümü</button>
          <button @click="filterType = 'in'" :class="btnClass('in')">Girişler</button>
          <button @click="filterType = 'out'" :class="btnClass('out')">Çıkışlar</button>
        </div>

        <div class="flex flex-wrap gap-2 items-end">
          <div>
            <label class="block text-xs text-gray-600 dark:text-gray-400 mb-1">Başlangıç Tarihi</label>
            <input type="date" v-model="startDate"
              class="h-10 px-3 rounded-lg border border-light-border dark:border-gray-600 bg-primary-bg dark:bg-gray-800 text-sm text-primary-text dark:text-gray-100 focus:border-indigo-500 focus:ring focus:ring-blue-100/50" />
          </div>
          <div>
            <label class="block text-xs text-gray-600 dark:text-gray-400 mb-1">Bitiş Tarihi</label>
            <input type="date" v-model="endDate"
              class="h-10 px-3 rounded-lg border border-light-border dark:border-gray-600 bg-primary-bg dark:bg-gray-800 text-sm text-primary-text dark:text-gray-100 focus:border-indigo-500 focus:ring focus:ring-blue-100/50" />
          </div>
          <button @click="applyFilter"
            class="bg-primary-button hover:bg-primary-button-hover text-white px-4 py-2 rounded text-sm">
            Filtrele
          </button>
        </div>
      </div>

      <div
        class="overflow-hidden rounded-md border border-light-border dark:border-dark-border bg-primary-bg dark:bg-primary-dark-bg shadow-md">
        <div class="w-full overflow-x-auto">
          <table class="min-w-full text-left text-sm dark:text-gray-300">
            <thead class="bg-gray-100 dark:bg-gray-800 font-medium">
              <tr>
                <th class="px-3 md:px-6 py-2 md:py-4">Tarih</th>
                <th class="px-3 md:px-6 py-2 md:py-4">Tip</th>
                <th class="px-3 md:px-6 py-2 md:py-4">Açıklama</th>
                <th class="px-3 md:px-6 py-2 md:py-4 text-right">Tutar (₺)</th>
                <th class="px-3 md:px-6 py-2 md:py-4 text-right"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="isLoading">
                <td colspan="5" class="text-center py-6 text-gray-500 dark:text-gray-400">
                  Yükleniyor...
                </td>
              </tr>
              <tr v-else-if="filteredCreditCardTransactions.length === 0">
                <td colspan="5" class="text-center py-6 text-gray-500 dark:text-gray-400">
                  Hiç kayıt bulunamadı.
                </td>
              </tr>

              <tr v-for="item in filteredCreditCardTransactions" :key="item.id"
                class="border-b border-light-border dark:border-dark-border transition hover:light-hover dark:hover:dark-hover">
                <td class="px-3 md:px-6 py-2 md:py-4">{{ formatDate(item.created_at) }}</td>
                <td class="px-3 md:px-6 py-2 md:py-4">
                  <span :class="item.type === 'in' ? 'bg-green-100 text-green-700 px-2 py-1 rounded text-xs font-medium' : 'bg-red-100 text-red-700 px-2 py-1 rounded text-xs font-medium'">
                    {{ item.type === 'in' ? 'Giriş' : 'Çıkış' }}
                  </span>
                </td>
                <td class="px-3 md:px-6 py-2 md:py-4">
                  <span v-if="isLoanPayment(item)" 
                        @click="goToLoanDetail(item)" 
                        class="cursor-pointer text-blue-600 hover:text-blue-800 underline">
                    {{ item.description }}
                  </span>
                  <span v-else>{{ item.description }}</span>
                </td>
                <td class="px-3 md:px-6 py-2 md:py-4 text-right">{{ formatPrice(item.amount) }} ₺</td>
                <td class="px-3 md:px-6 py-2 md:py-4 text-right">
                  <div class="flex justify-end gap-2">
                    <button v-if="!isLoanPayment(item) && item.driver_id" @click="convertToLoan(item)" 
                      class="ml-3" title="Veresiye'ye Çevir">
                      <ArrowPathIcon class="w-5 h-5 text-blue-500 hover:text-blue-700" />
                    </button>
                    <button v-if="!isLoanPayment(item)" @click="openEditModal(item)" class="ml-3" title="Düzenle">
                      <PencilSquareIcon class="w-5 h-5 text-gray-500 hover:text-secondary-text" />
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="my-4">
                  <AppPagination 
          :currentPage="currentPage" 
          :totalPages="totalPages" 
          :pageSize="pageSize"
          :totalItems="totalItems"
          @prev-page="handlePageChange(currentPage - 1)"
          @next-page="handlePageChange(currentPage + 1)"
          @go-to-page="handlePageChange"
          @update:pageSize="handlePageSizeChange"
        />
        </div>
      </div>

      <div class="bg-white dark:bg-primary-dark-bg p-6 rounded-lg shadow border border-light-border dark:border-dark-border mt-6">
        <h2 class="text-lg font-semibold mb-2">Yeni Kredi Kartı Kaydı Ekle</h2>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          <div>
            <label class="block mb-1">Tutar (₺)</label>
            <input v-model.number="form.amount" type="number" placeholder="Tutar giriniz"
              class="w-full border border-light-border dark:border-dark-border rounded px-3 py-2 dark:bg-gray-800 dark:text-white" />
          </div>
          <div>
            <label class="block mb-1">Tip</label>
            <select v-model="form.type"
              class="w-full border border-light-border dark:border-dark-border rounded px-3 py-2 dark:bg-gray-800 dark:text-white">
              <option disabled value="">Seçiniz</option>
              <option value="in">Giriş</option>
              <option value="out">Çıkış</option>
            </select>
          </div>
          <div>
            <label class="block mb-1">Açıklama</label>
            <input v-model="form.description" type="text" placeholder="Açıklama"
              class="w-full border border-light-border dark:border-dark-border rounded px-3 py-2 dark:bg-gray-800 dark:text-white" />
          </div>
        </div>

        <div class="flex justify-end">
          <button @click="submitTransaction"
            class="bg-primary-button hover:bg-primary-button-hover text-white px-4 py-2 rounded transition-all duration-200 text-sm">
            Kaydet
          </button>
        </div>
        
     
      </div>
    </div>

    <div v-if="activeTab === 'veresiye'">
      <div class="flex flex-col md:flex-row items-end justify-between mb-4 gap-4">
        <div class="flex gap-2">
          <button @click="loanFilterType = 'all'" :class="btnClass('all')">Tümü</button>
          <button @click="loanFilterType = 'debt'" :class="btnClass('debt')">Borçlar</button>
          <button @click="loanFilterType = 'payment'" :class="btnClass('payment')">Ödemeler</button>
        </div>

        <div class="flex flex-wrap gap-2 items-end">
          <div>
            <label class="block text-xs text-gray-600 dark:text-gray-400 mb-1">Başlangıç Tarihi</label>
            <input type="date" v-model="startDate"
              class="h-10 px-3 rounded-lg border border-light-border dark:border-gray-600 bg-primary-bg dark:bg-gray-800 text-sm text-primary-text dark:text-gray-100 focus:border-indigo-500 focus:ring focus:ring-blue-100/50" />
          </div>
          <div>
            <label class="block text-xs text-gray-600 dark:text-gray-400 mb-1">Bitiş Tarihi</label>
            <input type="date" v-model="endDate"
              class="h-10 px-3 rounded-lg border border-light-border dark:border-gray-600 bg-primary-bg dark:bg-gray-800 text-sm text-primary-text dark:text-gray-100 focus:border-indigo-500 focus:ring focus:ring-blue-100/50" />
          </div>
          <button @click="applyFilter"
            class="bg-primary-button hover:bg-primary-button-hover text-white px-4 py-2 rounded text-sm">
            Filtrele
          </button>
        </div>
      </div>

      <div
        class="overflow-hidden rounded-md border border-light-border dark:border-dark-border bg-primary-bg dark:bg-primary-dark-bg shadow-md">
        <div class="w-full overflow-x-auto">
          <table class="min-w-full text-left text-sm dark:text-gray-300">
            <thead class="bg-gray-100 dark:bg-gray-800 font-medium">
              <tr>
                <th class="px-3 md:px-6 py-2 md:py-4">Tarih</th>
                <th class="px-3 md:px-6 py-2 md:py-4">Sürücü</th>
                <th class="px-3 md:px-6 py-2 md:py-4">Tip</th>
                <th class="px-3 md:px-6 py-2 md:py-4 text-right">Tutar (₺)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="isLoading">
                <td colspan="4" class="text-center py-6 text-gray-500 dark:text-gray-400">
                  Yükleniyor...
                </td>
              </tr>
              <tr v-else-if="filteredLoanTransactions.length === 0">
                <td colspan="4" class="text-center py-6 text-gray-500 dark:text-gray-400">
                  Hiç kayıt bulunamadı.
                </td>
              </tr>

              <tr v-for="item in filteredLoanTransactions" :key="item.booklet_id"
                class="border-b border-light-border dark:border-dark-border transition hover:light-hover dark:hover:dark-hover">
                <td class="px-3 md:px-6 py-2 md:py-4">{{ formatDate(item.date) }}</td>
                <td class="px-3 md:px-6 py-2 md:py-4">
                  <span v-if="item.book && item.book.driver">
                    <a @click="goToDriverBooks(item.book.driver_id)" 
                       class="cursor-pointer text-blue-600 hover:text-blue-800 underline">
                      {{ item.book.driver.driver_name || 'Bilinmiyor' }}
                    </a>
                  </span>
                  <span v-else class="text-gray-400">-</span>
                </td>
                <td class="px-3 md:px-6 py-2 md:py-4">
                  <span v-if="item.is_payment" class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200">
                    Ödeme
                  </span>
                  <span v-else class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200">
                    Borç
                  </span>
                </td>
                <td class="px-3 md:px-6 py-2 md:py-4 text-right">{{ formatPrice(item.amount) }} ₺</td>
              </tr>
            </tbody>
          </table>
        </div>
    
      <div class="my-4">
        <AppPagination 
          :currentPage="currentLoanPage" 
          :totalPages="totalLoanPages" 
          :pageSize="loanPageSize"
          :totalItems="totalLoanItems"
          @prev-page="handleLoanPageChange(currentLoanPage - 1)"
          @next-page="handleLoanPageChange(currentLoanPage + 1)"
          @go-to-page="handleLoanPageChange"
          @update:pageSize="handleLoanPageSizeChange"
        />
      </div>
      </div>
    </div>
  </div>

  <!-- Edit Modal -->
  <div v-if="isEditModalOpen" class="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center px-4">
    <div class="bg-white dark:bg-gray-900 p-6 rounded shadow-md w-full max-w-md relative">
      <button @click="isEditModalOpen = false" class="absolute top-2 right-2 text-gray-500">✕</button>

      <h2 class="text-lg font-semibold mb-4">Kayıt Düzenle</h2>

      <div class="space-y-4">
        <div>
          <label class="block mb-1">Tutar (₺)</label>
          <input v-model.number="selectedTransaction.amount" type="number" 
            class="w-full border border-light-border dark:border-dark-border rounded px-3 py-2 dark:bg-gray-800 dark:text-white" />
        </div>

        <div>
          <label class="block mb-1">Tip</label>
          <select v-model="selectedTransaction.type" 
            class="w-full border border-light-border dark:border-dark-border rounded px-3 py-2 dark:bg-gray-800 dark:text-white">
            <option value="in">Giriş</option>
            <option value="out">Çıkış</option>
          </select>
        </div>

        <div>
          <label class="block mb-1">Ödeme Yöntemi</label>
          <select v-model="selectedPaymentMethod" 
            class="w-full border border-light-border dark:border-dark-border rounded px-3 py-2 dark:bg-gray-800 dark:text-white">
            <option value="cash">Nakit</option>
            <option value="creditCard">Kredi Kartı</option>
            <option value="partial">Parçalı</option>
          </select>
        </div>

        <div v-if="selectedPaymentMethod === 'partial'" class="grid grid-cols-2 gap-3">
          <div>
            <label class="block mb-1">Nakit (₺)</label>
            <input v-model.number="partialCashAmount" type="number" step="0.01" min="0" @input="onPartialCashChanged"
              class="w-full border border-light-border dark:border-dark-border rounded px-3 py-2 dark:bg-gray-800 dark:text-white" />
          </div>
          <div>
            <label class="block mb-1">Kart (₺)</label>
            <input v-model.number="partialCardAmount" type="number" step="0.01" min="0" @input="onPartialCardChanged"
              class="w-full border border-light-border dark:border-dark-border rounded px-3 py-2 dark:bg-gray-800 dark:text-white" />
          </div>
          <div class="col-span-2 text-xs text-secondary-text dark:text-gray-400">
            Toplam: {{ formatPrice((partialCashAmount || 0) + (partialCardAmount || 0)) }} ₺ / {{ formatPrice(selectedTransaction.amount) }} ₺
          </div>
        </div>

        <div>
          <label class="block mb-1">Açıklama</label>
          <input v-model="selectedTransaction.description" type="text" 
            class="w-full border border-light-border dark:border-dark-border rounded px-3 py-2 dark:bg-gray-800 dark:text-white" />
        </div>
      </div>

      <div class="flex justify-end gap-3 mt-6">
        <button @click="isEditModalOpen = false"
          class="border rounded px-4 py-2 transition-all duration-200 text-sm">Vazgeç</button>
        <button @click="submitEdit"
          class="bg-primary-button hover:bg-primary-button-hover text-white px-4 py-2 rounded transition-all duration-200 text-sm">Güncelle</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import { getApi, postApi, putApi } from "@/services/api"
import { useToast } from "vue-toastification";
import { PencilSquareIcon, ArrowPathIcon } from '@heroicons/vue/24/outline';
import { DateTime } from "luxon";
import * as XLSX from 'xlsx'

const router = useRouter()
const activeTab = ref('cash')

const cashTotalIncome = ref(0)
const cashTotalExpense = ref(0)
const cashNetBalance = ref(0)
const liveCashTotal = ref(0)
const totalLoanAmount = ref(0)

const creditCardTotalIncome = ref(0)
const creditCardTotalExpense = ref(0)

const filterType = ref('all')
const transactions = ref([])
const balance = ref(0)
const selectedTransaction = ref(null)
const selectedPaymentMethod = ref('cash') // 'cash', 'creditCard', or 'partial'
const isEditModalOpen = ref(false)
const isLoading = ref(false)
const partialCashAmount = ref(0)
const partialCardAmount = ref(0)

// Shared date filters across all tabs
const startDate = ref(DateTime.now().toFormat("yyyy-MM-dd"))
const endDate = ref(DateTime.now().toFormat("yyyy-MM-dd"))
const loanFilterType = ref('all')
const loanTransactions = ref([])
const currentLoanPage = ref(1)
const loanPageSize = ref(50)
const totalLoanItems = ref(0)

const currentPage = ref(1)
const pageSize = ref(50)
const totalItems = ref(0)

const form = ref({
  amount: null,
  type: '',
  description: ''
})

const openEditModal = (item) => {
  selectedTransaction.value = { ...item }
  // Determine payment method based on description
  const isCreditCard = item.description && item.description.toUpperCase().includes('KREDİ KARTI')
  selectedPaymentMethod.value = isCreditCard ? 'creditCard' : 'cash'
  
  // If it's credit card, remove the prefix from description for editing
  if (isCreditCard && item.description) {
    selectedTransaction.value.description = item.description.replace(/^KREDİ KARTI\s*-\s*/i, '').trim()
  }
  
  // Initialize partial amounts (default to split evenly if switching to partial)
  const total = Number(item.amount || 0)
  const half = Number((total / 2).toFixed(2))
  partialCashAmount.value = half
  partialCardAmount.value = Number((total - half).toFixed(2))
  
  isEditModalOpen.value = true
}

const onPartialCashChanged = () => {
  if (selectedPaymentMethod.value !== 'partial') return
  const total = Number(selectedTransaction.value.amount || 0)
  let cash = Number(partialCashAmount.value || 0)
  if (isNaN(cash) || cash < 0) cash = 0
  if (cash > total) cash = total
  partialCashAmount.value = cash
  partialCardAmount.value = Number((total - cash).toFixed(2))
}

const onPartialCardChanged = () => {
  if (selectedPaymentMethod.value !== 'partial') return
  const total = Number(selectedTransaction.value.amount || 0)
  let card = Number(partialCardAmount.value || 0)
  if (isNaN(card) || card < 0) card = 0
  if (card > total) card = total
  partialCardAmount.value = card
  partialCashAmount.value = Number((total - card).toFixed(2))
}

const toast = useToast();

const applyFilter = () => {
  if (activeTab.value === 'veresiye') {
    currentLoanPage.value = 1;
    fetchLoanTransactions();
  } else {
    currentPage.value = 1; 
    fetchTransactions()
    fetchSummary()
  }
}

const handlePageChange = (page) => {
  currentPage.value = page;
  fetchTransactions();
}

const handlePageSizeChange = (newPageSize) => {
  pageSize.value = newPageSize;
  currentPage.value = 1;
  fetchTransactions();
}

const handleLoanPageChange = (page) => {
  currentLoanPage.value = page;
  fetchLoanTransactions();
}

const handleLoanPageSizeChange = (newPageSize) => {
  loanPageSize.value = newPageSize;
  currentLoanPage.value = 1;
  fetchLoanTransactions();
}

const fetchTransactions = async () => {
  isLoading.value = true;

  try {
    const take = pageSize.value;
    const skip = (currentPage.value - 1) * pageSize.value;
    
    let url;
    
    const start_date = startDate.value
      ? DateTime.fromISO(startDate.value).startOf("day").toFormat("yyyy-MM-dd'T'HH:mm:ss")
      : "";

    const end_date = endDate.value
      ? DateTime.fromISO(endDate.value).endOf("day").toFormat("yyyy-MM-dd'T'HH:mm:ss")
      : "";

    if (activeTab.value === 'cash') {
      url = `/cashflow/${take}/${skip}?start_date=${start_date}&end_date=${end_date}`;
    } else {
      url = `/cashflow/credit-card-payments/${take}/${skip}?start_date=${start_date}&end_date=${end_date}`;
    }

    const response = await getApi(url);
    
    if (response && typeof response === 'object' && 'cashflows' in response) {
      transactions.value = response.cashflows || []
      totalItems.value = response.total_result || 0
    } else {
      transactions.value = Array.isArray(response) ? response : []
      totalItems.value = transactions.value.length
    }
    
    await fetchSummary();
  } catch (error) {
    toast.error("Kasa hareketleri alınamadı!")
  } finally {
    isLoading.value = false;
  }
}

const fetchBalance = async () => {
  try {
    const response = await getApi('/cashflow/balance')
    balance.value = response?.balance ?? 0
  } catch (error) {
    balance.value = 0
  }
}

const fetchSummary = async () => {
  try {
    const start_date = startDate.value
      ? DateTime.fromISO(startDate.value).startOf("day").toFormat("yyyy-MM-dd'T'HH:mm:ss")
      : "";

    const end_date = endDate.value
      ? DateTime.fromISO(endDate.value).endOf("day").toFormat("yyyy-MM-dd'T'HH:mm:ss")
      : "";

    const url = `/cashflow/?start_date=${start_date}&end_date=${end_date}`;

    const response = await getApi(url);
    
    if (response && typeof response === 'object') {
      cashTotalIncome.value = response.cash_total_income || 0
      cashTotalExpense.value = response.cash_total_expense || 0
      cashNetBalance.value = response.cash_net_balance || 0
      liveCashTotal.value = response.total_cash_amount || 0
      creditCardTotalIncome.value = response.credit_card_total_income || 0
      creditCardTotalExpense.value = response.credit_card_total_expense || 0
    }
    
    // Fetch loan total for the cash tab
    await fetchLoanTotal();
  } catch (error) {
    console.error("Özet hesaplanamadı:", error);
  }
}

const fetchLoanTransactions = async () => {
  isLoading.value = true;
  
  try {
    const take = loanPageSize.value;
    const skip = (currentLoanPage.value - 1) * loanPageSize.value;
    
    const start_date = startDate.value
      ? DateTime.fromISO(startDate.value).startOf("day").toFormat("yyyy-MM-dd'T'HH:mm:ss")
      : "";

    const end_date = endDate.value
      ? DateTime.fromISO(endDate.value).endOf("day").toFormat("yyyy-MM-dd'T'HH:mm:ss")
      : "";

    const url = `/books/booklets/${take}/${skip}?start_date=${start_date}&end_date=${end_date}`;
    const response = await getApi(url);
    
    if (response && typeof response === 'object' && 'booklets' in response) {
      loanTransactions.value = response.booklets || []
      totalLoanItems.value = response.total_result || 0
    } else {
      loanTransactions.value = Array.isArray(response) ? response : []
      totalLoanItems.value = loanTransactions.value.length
    }
  } catch (error) {
    toast.error("Veresiye hareketleri alınamadı!")
    loanTransactions.value = []
    totalLoanItems.value = 0
  } finally {
    isLoading.value = false;
  }
}

const fetchLoanTotal = async () => {
  try {
    const start_date = startDate.value
      ? DateTime.fromISO(startDate.value).startOf("day").toFormat("yyyy-MM-dd'T'HH:mm:ss")
      : "";

    const end_date = endDate.value
      ? DateTime.fromISO(endDate.value).endOf("day").toFormat("yyyy-MM-dd'T'HH:mm:ss")
      : "";

    const url = `/books/total-loan-range?start_date=${start_date}&end_date=${end_date}`;
    const response = await getApi(url);
    
    if (response && typeof response === 'object') {
      totalLoanAmount.value = response.total_loan || 0
    }
  } catch (error) {
    console.error("Veresiye toplamı hesaplanamadı:", error);
    totalLoanAmount.value = 0
  }
}

onMounted(() => {
  fetchTransactions()
  fetchBalance()
  fetchSummary()
  fetchLoanTransactions()
  fetchLoanTotal()
})

watch(activeTab, () => {
  if (activeTab.value === 'veresiye') {
    currentLoanPage.value = 1;
    fetchLoanTransactions();
  } else {
    currentPage.value = 1; 
    fetchTransactions()
    if (activeTab.value === 'cash') {
      fetchLoanTotal();
    }
  }
})

watch(pageSize, () => {
  currentPage.value = 1;
  fetchTransactions();
})

watch([startDate, endDate], () => {
  // When dates change, refresh the current tab's data
  if (activeTab.value === 'veresiye') {
    currentLoanPage.value = 1;
    fetchLoanTransactions();
  } else if (activeTab.value === 'cash') {
    currentPage.value = 1;
    fetchTransactions();
    fetchSummary();
  } else {
    currentPage.value = 1;
    fetchTransactions();
    fetchSummary();
  }
})

watch(selectedPaymentMethod, (val) => {
  if (!selectedTransaction.value) return
  
  if (val === 'partial') {
    // Initialize split evenly by default
    const total = Number(selectedTransaction.value.amount || 0)
    const half = Number((total / 2).toFixed(2))
    partialCashAmount.value = half
    partialCardAmount.value = Number((total - half).toFixed(2))
  }
})

watch(() => selectedTransaction.value?.amount, (total) => {
  if (selectedPaymentMethod.value === 'partial' && total) {
    const cash = Number(partialCashAmount.value || 0)
    // Keep cash within 0..total, recompute card
    let newCash = isNaN(cash) ? 0 : cash
    if (newCash < 0) newCash = 0
    if (newCash > Number(total || 0)) newCash = Number(total || 0)
    partialCashAmount.value = newCash
    partialCardAmount.value = Number(((Number(total || 0)) - newCash).toFixed(2))
  }
})

const filteredCashTransactions = computed(() => {
  if (filterType.value === 'all') return transactions.value
  return transactions.value.filter(t => t.type === filterType.value)
})

const filteredCreditCardTransactions = computed(() => {
  // Filter credit card transactions
  const creditCardTransactions = transactions.value.filter(t => 
    t.description && t.description.toUpperCase().includes('KREDİ KARTI')
  )
  if (filterType.value === 'all') return creditCardTransactions
  return creditCardTransactions.filter(t => t.type === filterType.value)
})

const filteredLoanTransactions = computed(() => {
  if (loanFilterType.value === 'all') return loanTransactions.value
  if (loanFilterType.value === 'debt') return loanTransactions.value.filter(t => !t.is_payment)
  if (loanFilterType.value === 'payment') return loanTransactions.value.filter(t => t.is_payment)
  return loanTransactions.value
})

const totalPages = computed(() => {
  return Math.ceil(totalItems.value / pageSize.value);
})

const totalLoanPages = computed(() => {
  return Math.ceil(totalLoanItems.value / loanPageSize.value);
})

const tabBtnClass = (tab) =>
  activeTab.value === tab
    ? 'bg-primary-button hover:bg-primary-button-hover text-white px-6 py-3 rounded-lg transition-all duration-200 text-sm font-medium'
    : 'bg-gray-200 dark:bg-gray-700 text-black dark:text-white px-6 py-3 rounded-lg transition-all duration-200 text-sm font-medium'

const btnClass = (type) => {
  let isActive = false;
  if (activeTab.value === 'veresiye') {
    isActive = loanFilterType.value === type;
  } else {
    isActive = filterType.value === type;
  }
  return isActive
    ? 'bg-primary-button hover:bg-primary-button-hover text-white px-4 py-2 rounded transition-all duration-200 text-sm'
    : 'bg-gray-200 dark:bg-gray-700 text-black dark:text-white px-4 py-2 rounded transition-all duration-200 text-sm'
}

const exportToExcel = async () => {
  try {
    const take = 100000
    const skip = 0

    // Prepare URLs for both Cash and Credit Card
    const cashStart = startDate.value
      ? DateTime.fromISO(startDate.value).startOf("day").toFormat("yyyy-MM-dd'T'HH:mm:ss")
      : ""
    const cashEnd = endDate.value
      ? DateTime.fromISO(endDate.value).endOf("day").toFormat("yyyy-MM-dd'T'HH:mm:ss")
      : ""
    const cashUrl = `/cashflow/${take}/${skip}?start_date=${cashStart}&end_date=${cashEnd}`

    const ccStart = startDate.value
      ? DateTime.fromISO(startDate.value).startOf("day").toFormat("yyyy-MM-dd'T'HH:mm:ss")
      : ""
    const ccEnd = endDate.value
      ? DateTime.fromISO(endDate.value).endOf("day").toFormat("yyyy-MM-dd'T'HH:mm:ss")
      : ""
    const ccUrl = `/cashflow/credit-card-payments/${take}/${skip}?start_date=${ccStart}&end_date=${ccEnd}`

    const loanStartISO = startDate.value
      ? DateTime.fromISO(startDate.value).startOf("day").toFormat("yyyy-MM-dd'T'HH:mm:ss")
      : ""
    const loanEndISO = endDate.value
      ? DateTime.fromISO(endDate.value).endOf("day").toFormat("yyyy-MM-dd'T'HH:mm:ss")
      : ""

    const [cashResp, ccResp, loanResp] = await Promise.all([
      getApi(cashUrl),
      getApi(ccUrl),
      getApi(`/books/booklets/${take}/${skip}?start_date=${loanStartISO}&end_date=${loanEndISO}`)
    ])

    const itemsCash = (cashResp && typeof cashResp === 'object' && 'cashflows' in cashResp)
      ? (cashResp.cashflows || [])
      : (Array.isArray(cashResp) ? cashResp : [])

    const itemsCc = (ccResp && typeof ccResp === 'object' && 'cashflows' in ccResp)
      ? (ccResp.cashflows || [])
      : (Array.isArray(ccResp) ? ccResp : [])

    itemsCash.sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
    itemsCc.sort((a, b) => new Date(a.created_at) - new Date(b.created_at))

    const booklets = (loanResp && typeof loanResp === 'object' && 'booklets' in loanResp)
      ? (loanResp.booklets || [])
      : (Array.isArray(loanResp) ? loanResp : [])

    const loanTotals = booklets.reduce(
      (acc, booklet) => {
        const amount = Number(booklet.amount) || 0
        if (booklet.is_payment) {
          acc.paid += amount
        } else {
          acc.debt += amount
        }
        return acc
      },
      { debt: 0, paid: 0 }
    )

    const buildSheet = async (title, startLabel, endLabel, items, options = {}) => {
      const header = [[`${title} Hareketleri (${startLabel} - ${endLabel})`]]
      const tableHeader = [["Tarih", "Tip", "Açıklama", "Tutar (₺)"]]

      let totalIn = 0
      let totalOut = 0

      const rows = items.map((t) => {
        const amount = Number(t.amount) || 0
        if (t.type === 'in') totalIn += amount
        if (t.type === 'out') totalOut += amount
        return [
          formatDate(t.created_at),
          t.type === 'in' ? 'Giriş' : 'Çıkış',
          t.description || '',
          amount,
        ]
      })

      const totals = []
      totals.push(["", "", "Toplam Giriş", totalIn])
      totals.push(["", "", "Toplam Çıkış", totalOut])

      if (options.kind === 'cash') {
        const startISO = (startLabel ? DateTime.fromISO(startLabel).startOf('day').toFormat("yyyy-MM-dd'T'HH:mm:ss") : '')
        const endISO = (endLabel ? DateTime.fromISO(endLabel).endOf('day').toFormat("yyyy-MM-dd'T'HH:mm:ss") : '')
        let summary = null
        try {
          summary = await getApi(`/cashflow/?start_date=${startISO}&end_date=${endISO}`)
        } catch (e) {
          console.debug('Failed to fetch cash summary for export', e)
        }
        const totalInComputed = rows.reduce((acc, r) => acc + (r[1] === 'Giriş' ? Number(r[3]) : 0), 0)
        const totalOutComputed = rows.reduce((acc, r) => acc + (r[1] === 'Çıkış' ? Number(r[3]) : 0), 0)
        const net = summary?.cash_net_balance ?? (totalInComputed - totalOutComputed)
        const totalCashAmount = summary?.total_cash_amount ?? net
        const diff = (totalCashAmount - net)

        // Also include "Toplam Hesap Giriş" (credit card income within date range)
        let accountIncome = 0
        try {
          const ccSummary = await getApi(`/cashflow/?start_date=${startISO}&end_date=${endISO}`)
          accountIncome = ccSummary?.credit_card_total_income || 0
        } catch (e) {
          console.debug('Failed to fetch credit card income for export', e)
        }

        totals.push(["", "", "Toplam Nakit Giriş", summary?.cash_total_income ?? totalInComputed])
        totals.push(["", "", "Toplam Nakit Çıkış", summary?.cash_total_expense ?? totalOutComputed])
        totals.push(["", "", "Toplam Hesap Giriş", accountIncome])
        if (options.loanTotals) {
          totals.push(["", "", "Toplam Borçlanma", options.loanTotals.debt])
          totals.push(["", "", "Toplam Borç Kapatma", options.loanTotals.paid])
        }
        totals.push(["", "", "Net Nakit Bakiye (Dönem)", net])
        totals.push(["", "", "Canlı Kasa", totalCashAmount])
        if (diff !== 0) totals.push(["", "", "Devreden Bakiye", diff])
      } else if (options.kind === 'creditCard') {
        const net = (creditCardTotalIncome.value || 0) - (creditCardTotalExpense.value || 0)
        totals.push(["", "", "Net Bakiye", net])
      }

      const aoa = [
        ...header,
        [""],
        ...tableHeader,
        ...rows,
      ]

      if (options.creditItems && options.creditItems.length > 0) {
        const creditRows = options.creditItems.map((t) => [
          formatDate(t.created_at),
          t.type === 'in' ? 'Giriş' : 'Çıkış',
          t.description || '',
          Number(t.amount) || 0,
        ])
        aoa.push([""])
        aoa.push([`Kredi Kartı Hareketleri (${startLabel} - ${endLabel})`])
        aoa.push(["Tarih", "Tip", "Açıklama", "Tutar (₺)"])
        aoa.push(...creditRows)
      }

      if (options.loanItems && options.loanItems.length > 0) {
        const loanRows = options.loanItems.map((b) => {
          const driverName = b.book?.driver?.driver_name || 'Bilinmiyor'
          const description = b.description ? `${driverName} - ${b.description}` : driverName
          return [
            formatDate(b.date),
            b.is_payment ? 'Ödeme' : 'Borç',
            description,
            Number(b.amount) || 0,
          ]
        })
        aoa.push([""])
        aoa.push([`Veresiye Hareketleri (${startLabel} - ${endLabel})`])
        aoa.push(["Tarih", "Tip", "Açıklama", "Tutar (₺)"])
        aoa.push(...loanRows)
      }

      aoa.push([""])
      aoa.push(...totals)

      const ws = XLSX.utils.aoa_to_sheet(aoa)
      ws['!cols'] = [
        { wch: 18 },
        { wch: 10 },
        { wch: 60 },
        { wch: 16 },
      ]
      return ws
    }

    const wb = XLSX.utils.book_new()
    const cashSheet = await buildSheet('Nakit Kasa', startDate.value, endDate.value, itemsCash, { kind: 'cash', loanTotals, creditItems: itemsCc, loanItems: booklets })
    const ccSheet = await buildSheet('Kredi Kartı', startDate.value, endDate.value, itemsCc, { kind: 'creditCard' })

    XLSX.utils.book_append_sheet(wb, cashSheet, 'Nakit Kasa')
    XLSX.utils.book_append_sheet(wb, ccSheet, 'Kredi Kartı')

    const fileName = `Kasa_Raporu_${startDate.value}_to_${endDate.value}.xlsx`
    XLSX.writeFile(wb, fileName)
  } catch (e) {
    toast.error('Excel oluşturulamadı')
  }
}

const submitTransaction = async () => {
  if (!form.value.amount || !form.value.type) {
    toast.error("Tutar ve tür zorunludur!");
    return
  }

  try {
    let description = form.value.description
    
    if (activeTab.value === 'creditCard' && (!description || !description.toUpperCase().includes('KREDİ KARTI'))) {
      description = `KREDİ KARTI - ${description || ''}`
    }

    const payload = {
      amount: form.value.amount,
      type: form.value.type,
      description: description,
      driver_id: null,
      vehicle_plate: null
    }

    const newEntry = await postApi('/cashflow/', payload)
    transactions.value.unshift(newEntry)

    form.value.amount = null
    form.value.type = ''
    form.value.description = ''

    const successMessage = activeTab.value === 'creditCard' ? 'Kredi kartı kaydı başarıyla eklendi.' : 'Nakit kasa kaydı başarıyla eklendi.'
    toast.success(successMessage);

    await fetchTransactions()
    await fetchBalance()
  } catch (error) {
    const errorMessage = activeTab.value === 'creditCard' ? 'Kredi kartı kaydı ekleme hatası!' : 'Nakit kasa kaydı ekleme hatası!'
    toast.error(errorMessage);
  }
}

const submitEdit = async () => {
  if (!selectedTransaction.value) return;

  try {
    const total = Number(selectedTransaction.value.amount || 0)
    
    // Validate partial payment
    if (selectedPaymentMethod.value === 'partial') {
      const cash = Number(partialCashAmount.value || 0)
      const card = Number(partialCardAmount.value || 0)
      if (cash < 0 || card < 0 || Math.abs((cash + card) - total) >= 0.005) {
        toast.error('Parçalı ödemede nakit ve kart toplamı tutar ile eşit olmalıdır.')
        return
      }
    }

    // Transform description based on payment method
    let description = selectedTransaction.value.description || ''
    
    if (selectedPaymentMethod.value === 'partial') {
      // For partial payments, update current entry to cash and create/update credit card entry
      const cash = Number(partialCashAmount.value || 0)
      const card = Number(partialCardAmount.value || 0)
      
      // Remove KREDİ KARTI prefix for cash entry
      description = description.replace(/^KREDİ KARTI\s*-\s*/i, '').trim()
      
      // Update current entry to be cash portion
      await putApi(`/cashflow/update/${selectedTransaction.value.id}`, {
        amount: cash,
        type: selectedTransaction.value.type,
        description: description,
        driver_id: selectedTransaction.value.driver_id || null,
        vehicle_plate: selectedTransaction.value.vehicle_plate || null,
        delivery_id: selectedTransaction.value.delivery_id || null,
      })

      // Create or update credit card entry
      const creditCardDescription = `KREDİ KARTI - ${description}`
      
      // Check if there's an existing credit card entry with same delivery_id
      // For now, we'll create a new entry. In a more sophisticated system, we could track related entries
      await postApi('/cashflow/', {
        amount: card,
        type: selectedTransaction.value.type,
        description: creditCardDescription,
        driver_id: selectedTransaction.value.driver_id || null,
        vehicle_plate: selectedTransaction.value.vehicle_plate || null,
        delivery_id: selectedTransaction.value.delivery_id || null,
      })

      toast.success("Kasa kaydı parçalı ödeme olarak güncellendi.");
    } else {
      // For non-partial payments, handle as before
      if (selectedPaymentMethod.value === 'creditCard') {
        // Add KREDİ KARTI prefix if not already present
        if (!description.toUpperCase().includes('KREDİ KARTI')) {
          description = `KREDİ KARTI - ${description}`
        }
      } else {
        // Remove KREDİ KARTI prefix if present
        description = description.replace(/^KREDİ KARTI\s*-\s*/i, '').trim()
      }

      await putApi(`/cashflow/update/${selectedTransaction.value.id}`, {
        amount: selectedTransaction.value.amount,
        type: selectedTransaction.value.type,
        description: description,
        driver_id: selectedTransaction.value.driver_id || null,
        vehicle_plate: selectedTransaction.value.vehicle_plate || null,
        delivery_id: selectedTransaction.value.delivery_id || null,
      });

      toast.success("Kasa kaydı güncellendi.");
    }
    
    isEditModalOpen.value = false;
    await fetchTransactions();
    await fetchBalance();
    await fetchSummary();
  } catch (err) {
    toast.error("Kayıt güncellenemedi.");
  }
}

const formatDate = (isoDate) => {
  const date = new Date(isoDate)
  return date.toLocaleString('tr-TR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  })
}

const formatPrice = (value) => {
  if (value === null || value === undefined) return '0,00';
  const parts = parseFloat(value).toFixed(2).split('.');
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  const decimalPart = parts[1];
  return `${integerPart},${decimalPart}`;
}

const isLoanPayment = (item) => {
  return item.description && item.description.toUpperCase().includes('VERESİYE');
}

const goToLoanDetail = (item) => {
  if (item.driver_id) {
    router.push(`/drivers/${item.driver_id}/books`);
  } else {
    toast.warning("Sürücü bilgisi bulunamadı!");
  }
}

const goToDriverBooks = (driverId) => {
  if (driverId) {
    router.push(`/drivers/${driverId}/books`);
  } else {
    toast.warning("Sürücü bilgisi bulunamadı!");
  }
}

const convertToLoan = async (item) => {
  if (!item.driver_id) {
    toast.warning("Bu kayıt sürücü bilgisi içermiyor. Veresiye'ye çevirmek için sürücü bilgisi gereklidir.");
    return;
  }

  try {
    const Swal = (await import('sweetalert2')).default;
    const result = await Swal.fire({
      title: 'Kasa kaydını veresiye\'ye çevirmek istediğinize emin misiniz?',
      html: `
        <div class="text-left">
          <p class="mb-2"><strong>Tutar:</strong> ${formatPrice(item.amount)} ₺</p>
          <p class="mb-2"><strong>Açıklama:</strong> ${item.description || '-'}</p>
          <p class="text-sm text-gray-600 dark:text-gray-400 mt-3">
            Bu işlem kasa kaydını silecek ve sürücü için veresiye kaydı oluşturacaktır.
          </p>
        </div>
      `,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Evet, veresiye\'ye çevir',
      cancelButtonText: 'Vazgeç',
      buttonsStyling: false,
      customClass: {
        confirmButton: 'px-4 py-2 rounded bg-blue-600 hover:bg-blue-700 text-white',
        cancelButton: 'ml-2 px-4 py-2 rounded bg-gray-500 hover:bg-gray-600 text-white'
      },
      background: document.documentElement.classList.contains('dark') ? '#1f2937' : '#ffffff',
      color: document.documentElement.classList.contains('dark') ? '#e5e7eb' : '#111827',
    });

    if (!result.isConfirmed) return;

    // Call the backend endpoint
    await postApi(`/cashflow/convert-to-loan/${item.id}`);
    
    toast.success("Kasa kaydı başarıyla veresiye'ye çevrildi.");
    
    // Refresh the data
    await fetchTransactions();
    await fetchBalance();
    await fetchSummary();
  } catch (error) {
    console.error("Veresiye'ye çevirme hatası:", error);
    const errorMessage = error.response?.data?.detail || "Kasa kaydı veresiye'ye çevrilemedi!";
    toast.error(errorMessage);
  }
}
</script>
